export default function LongLeadItemsPanel({
  items,
  savingId,
  newItem,
  adding,
  onSave,
  onDelete,
  onNewItemChange,
  onAdd,
}) {
  const cellInput = {
    width: "100%", padding: "4px 8px", fontSize: 13,
    border: "1px solid var(--cs-border)", borderRadius: 5,
    background: "var(--surface)", color: "var(--text)",
  };

  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text2)", marginBottom: 12 }}>
        Long Lead Items
      </div>

      <div style={{ border: "1px solid var(--cs-border)", borderRadius: 8, overflow: "hidden" }}>
        {/* Header */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 140px 90px 130px 130px 40px", background: "#f8f9fb", borderBottom: "1px solid var(--cs-border)" }}>
          {["Item", "Vendor", "Lead Time (wks)", "Order-by Date", "Expected Delivery", ""].map(h => (
            <div key={h} style={{ padding: "8px 14px", fontSize: 11, fontWeight: 700, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "0.06em" }}>{h}</div>
          ))}
        </div>

        {/* Item rows */}
        {items.map((li, i) => (
          <div key={li.TurnoverLongLeadItemID} style={{
            display: "grid", gridTemplateColumns: "1fr 140px 90px 130px 130px 40px",
            borderBottom: i < items.length - 1 ? "1px solid var(--cs-border)" : "none",
            alignItems: "center",
            background: i % 2 === 0 ? "transparent" : "#fafbfc",
          }}>
            <div style={{ padding: "8px 14px" }}>
              {li.IsCustom ? (
                <input
                  defaultValue={li.ItemName}
                  onBlur={e => { if (e.target.value !== li.ItemName) onSave({ ...li, ItemName: e.target.value }); }}
                  style={{ width: "100%", border: "none", background: "transparent", fontSize: 13, color: "var(--text)", fontFamily: "inherit", outline: "none", fontStyle: "italic" }}
                />
              ) : (
                <span style={{ fontSize: 13, color: "var(--text)", fontWeight: 600 }}>{li.ItemName}</span>
              )}
            </div>
            <div style={{ padding: "6px 14px" }}>
              <input
                defaultValue={li.Vendor || ""}
                onBlur={e => onSave({ ...li, Vendor: e.target.value || null })}
                placeholder="—"
                style={cellInput}
              />
            </div>
            <div style={{ padding: "6px 14px" }}>
              <input
                type="number"
                defaultValue={li.LeadTimeWeeks ?? ""}
                onBlur={e => onSave({ ...li, LeadTimeWeeks: e.target.value ? parseInt(e.target.value) : null })}
                placeholder="—"
                style={cellInput}
              />
            </div>
            <div style={{ padding: "6px 14px" }}>
              <input
                type="date"
                defaultValue={li.OrderByDate ? li.OrderByDate.split("T")[0] : ""}
                onBlur={e => onSave({ ...li, OrderByDate: e.target.value || null })}
                style={{ ...cellInput, opacity: savingId === li.TurnoverLongLeadItemID ? 0.5 : 1 }}
              />
            </div>
            <div style={{ padding: "6px 14px" }}>
              <input
                type="date"
                defaultValue={li.ExpectedDeliveryDate ? li.ExpectedDeliveryDate.split("T")[0] : ""}
                onBlur={e => onSave({ ...li, ExpectedDeliveryDate: e.target.value || null })}
                style={{ ...cellInput, opacity: savingId === li.TurnoverLongLeadItemID ? 0.5 : 1 }}
              />
            </div>
            <div style={{ padding: "6px 8px", textAlign: "center" }}>
              <button
                onClick={() => onDelete(li)}
                title={li.IsCustom ? "Remove item" : "Remove this item from long lead tracking"}
                style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14, color: "#d1d5db", padding: "2px 4px" }}
                onMouseEnter={e => e.currentTarget.style.color = "#dc2626"}
                onMouseLeave={e => e.currentTarget.style.color = "#d1d5db"}
              >
                🗑
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Add custom item */}
      <div style={{ display: "flex", gap: 8, marginTop: 10, alignItems: "center", flexWrap: "wrap" }}>
        <input
          value={newItem.name}
          onChange={e => onNewItemChange({ ...newItem, name: e.target.value })}
          placeholder="Add long lead item…"
          style={{ flex: "1 1 200px", padding: "6px 10px", fontSize: 13, border: "1px solid var(--cs-border)", borderRadius: 6, background: "var(--surface)", color: "var(--text)" }}
        />
        <input
          value={newItem.vendor}
          onChange={e => onNewItemChange({ ...newItem, vendor: e.target.value })}
          placeholder="Vendor"
          style={{ width: 140, padding: "6px 10px", fontSize: 13, border: "1px solid var(--cs-border)", borderRadius: 6, background: "var(--surface)", color: "var(--text)" }}
        />
        <input
          type="number"
          value={newItem.leadTimeWeeks}
          onChange={e => onNewItemChange({ ...newItem, leadTimeWeeks: e.target.value })}
          placeholder="Wks"
          style={{ width: 70, padding: "6px 10px", fontSize: 13, border: "1px solid var(--cs-border)", borderRadius: 6, background: "var(--surface)", color: "var(--text)" }}
        />
        <input
          type="date"
          value={newItem.orderByDate}
          onChange={e => onNewItemChange({ ...newItem, orderByDate: e.target.value })}
          style={{ padding: "6px 10px", fontSize: 13, border: "1px solid var(--cs-border)", borderRadius: 6, background: "var(--surface)", color: "var(--text)" }}
        />
        <input
          type="date"
          value={newItem.expectedDeliveryDate}
          onChange={e => onNewItemChange({ ...newItem, expectedDeliveryDate: e.target.value })}
          style={{ padding: "6px 10px", fontSize: 13, border: "1px solid var(--cs-border)", borderRadius: 6, background: "var(--surface)", color: "var(--text)" }}
        />
        <button
          onClick={onAdd}
          disabled={adding || !newItem.name.trim()}
          style={{
            padding: "6px 16px", fontSize: 13, fontWeight: 700,
            background: "var(--cs-blue)", color: "#fff",
            border: "none", borderRadius: 6, cursor: "pointer",
            opacity: (adding || !newItem.name.trim()) ? 0.5 : 1,
            whiteSpace: "nowrap",
          }}
        >
          {adding ? "Adding…" : "+ Add"}
        </button>
      </div>
    </div>
  );
}
